import React, {Component} from "react";
import '../../assets/styles/snack_ads.css';

class DMPU extends Component {

    componentDidMount() {
        (window.units = window.units || []).push({});
        try {
            window.killSlot([this.props.id]);
            window.refreshBid([this.props.id]);
        } catch (e) {
            
        }
    }

    render() {
        return (
            <div className={'dmpu'}>
                <div id={this.props.id}/>
            </div>
        );
    }

}

export default DMPU;